import { Modal, Stack, Typography, Box, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const ModelBox = ({
  title,
  children,
  closeFunc,
  openVar,
  titleStyle,
  modelBorderRadius,
  justifyContent,
  px,
  className,
  padding = true,
  isHeaderVisiable = true,
  maxWidth,
  maxHeight,
  ...rest
}) => {
  return (
    <Dialog
      open={openVar}
      onClose={closeFunc}
      className={className}
      sx={{ zIndex: 900 }}
      PaperProps={{
        sx: {
          borderRadius: modelBorderRadius ? modelBorderRadius : "12px",
          height: "auto",
          ...(maxWidth && { maxWidth }),
          ...rest
        },
      }}
    >
      <Stack>
        <Stack
          sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)" }}
          direction="row"
          justifyContent="space-between"
          py={{ xs: "12px", md: "18px" }}
          display={!isHeaderVisiable && "none"}
        >
          <Stack direction="row" mx={1} width="100%" alignItems="center">
            <Typography sx={{ ...titleStyle, fontSize: { xs: "18px", md: "24px" } }} component="h2">
              {title}
            </Typography>
          </Stack>
          <Box
            onClick={closeFunc}
            sx={{
              padding: "4px",
              width: { lg: "54px", xs: "40px" },
              height: { lg: "54px", xs: "40px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <CloseIcon sx={{ fontSize: { xs: "24px", md: "30px" } }} />
          </Box>
        </Stack>
        <Stack sx={{ padding: padding ? { xs: "16px", md: "36px" } : "0" }}>{children}</Stack>
      </Stack>
    </Dialog>
  );
};

export default ModelBox;
